"use client"

import BusinessSector from "./componants/BusinessSector";
import Card from "./componants/Card";
import Customer from "./componants/Customer";
import Footer from "./componants/Footer";
import Hero from "./componants/Hero";
import JoinUs from "./componants/JoinUs";
import Security from "./componants/Security";
import Team from "./componants/Team";
import MarqueeComponant from "./componants/MarqueeComponant";
import Header from "./componants/Header";
import BannerAnimation from "./componants/BannerAnimation";
import Metrics from "./componants/Metrics";
import React, { useEffect, useRef  } from 'react';
import dynamic from 'next/dynamic'
import Accompagnement from "./componants/Accompagnement";
import Reporting from "./componants/Reporting";
import Script from "next/script";
import ScrollToTop from "react-scroll-to-top";
import Faq from "./componants/FaqComponent";
import ManifestText from "./componants/ManifestText";

import Image from "next/image";
import { useState } from "react";

import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";



export default function Home() {

  const pathRef = useRef<SVGPathElement | null>(null);
  const triggerDivRef = useRef<HTMLDivElement | null>(null);
  let isMounted = true;
  
  const [visible, setVisible] = useState(false)
  const vimeo = useRef<HTMLIFrameElement | null>(null);
  const [entervideo, setEntervideo] = useState(false)


  function drawPath(scroll: number) {
      if (pathRef.current !== null && triggerDivRef.current !== null) {
        pathRef.current.style.strokeDasharray = "2092"
        pathRef.current.style.opacity = "100"


        const length = pathRef.current.getTotalLength();

        const triggerOffset =
        triggerDivRef.current.getBoundingClientRect().top +
        window.scrollY -
        window.innerHeight;

      if (length - (scroll * length / triggerOffset) <= 0) {
        pathRef.current.style.strokeDashoffset = "0";
        setVisible(true)
      } else {
        const drawLength = length - (scroll * length / triggerOffset);
        pathRef.current.style.strokeDashoffset = Math.round(drawLength).toString();
      }
    }
  }

  function handleScroll() {
    if (isMounted) {
      const scroll = window.scrollY;
      drawPath(scroll);
    }
  }

  useEffect(() => {
    let isMounted = true;
    
  

  
      // Ajoutez un gestionnaire de scroll pour déclencher le dessin du path
      window.addEventListener("scroll", handleScroll);
  
      // Assurez-vous de retirer le gestionnaire d'événements lors du démontage du composant
      return () => {
        isMounted = false;
        window.removeEventListener("scroll", handleScroll);
      };
    
  }, []);

  


  
  
  
  const STYLES = { videoIframeContainer: { padding: '56.25% 0 0 0', position: 'relative', }, videoIframe: { position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' } }
  

  const vimeoIframeRef = useRef(null);

  useEffect(() => {
    CookieConsent.run({

      categories: {
          necessary: {
              enabled: true,  // this category is enabled by default
              readOnly: true  // this category cannot be disabled
          },
          analytics: {}
      },

      guiOptions: {
        consentModal: {
            layout: 'box',
            position: 'bottom left',
            flipButtons: false,
            equalWeightButtons: true
        },
        preferencesModal: {
            layout: 'box',
            // position: 'left right',
            flipButtons: false,
            equalWeightButtons: true
        }
    },
  
      language: {
          default: 'fr',
          translations: {
              fr: {
                  consentModal: {
                      title: 'Nous utilisons les cookies 🍪',
                      description: 'Nous utilisons des cookies et d\'autres technologies similaires afin de personnaliser notre contenu, mesurer l\'efficacité de nos publicités et améliorer leur pertinence, ainsi que proposer une meilleure expérience utilisateur.',
                      acceptAllBtn: 'J\'accepte tout',
                      acceptNecessaryBtn: 'Je n\'accepte rien',
                      showPreferencesBtn: 'Paramétrer'
                  },
                  preferencesModal: {
                      title: 'Paramétrez vos préférences 🍪',
                      acceptAllBtn: 'J\'accepte tout',
                      acceptNecessaryBtn: 'Je n\'accepte rien',
                      savePreferencesBtn: 'Accepter la selection actuelle',
                      closeIconLabel: 'Close modal',
                      sections: [
                          {
                              title: 'A quoi peuvent bien nous servir les cookies ?',
                          },
                          {
                              title: 'Fonctionnalités essentielles',
                              description: 'Sans ces fonctionnalités essentielles, nous pourrions ne pas être en mesure de vous permettre d’accéder à notre site web ou application et de vous fournir nos services de façon optimale. Il s’agit par exemple de la conservation vos choix concernant le dépôt de cookies.',
                              linkedCategory: 'necessary'
                          },
                          {
                              title: 'Mesure d\'audience',
                              description: 'La mesure d’audience nous permet de suivre la fréquentation de notre site ou application et à mieux comprendre la façon dont vous consultez nos contenus et utilisez nos services, ce qui nous aide dans notre démarche d’amélioration continue.',
                              linkedCategory: 'analytics'
                          },
                          {
                              title: 'Besoin de plus d\informations ?',
                              description: 'Pour toute question relative à notre politique en matière de cookies et à vos choix, veuillez <a href="mailto:cyril@heelio.io">nous contacter</a>'
                          }
                      ]
                  }
              }
          }
      }
  });
  }, []);


  return (
    <div className="bg-[#FAFAFA] min-h-[100vh]">
        <Script src="https://player.vimeo.com/api/player.js"></Script>

      <div className="max-w-[2000px] mx-auto">

        <Header/>
        <Hero/>
        <MarqueeComponant/>
        <div className="relative">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="1024"
            height="1024"
            viewBox="0 0 1024 1024"
            style={{ width: "100%", height: "100%", zIndex:"0" }}
            preserveAspectRatio="xMidYMid meet"
            className="absolute opacity-0 md:opacity-100"
          >

            <g clipPath="url(#__lottie_element_29)">
              <g transform="matrix(1,0,0,1,512,512)" opacity="1" style={{ display: "block" }}>
                <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                  <path
                    style={{opacity:"0"}}
                    ref={pathRef}
                    strokeDashoffset={200}
                    id="pathDraw"
                    strokeLinecap="butt"
                    strokeLinejoin="miter"
                    fillOpacity="0"
                    strokeMiterlimit="4"
                    stroke="#FED90F"
                    strokeOpacity="1"
                    strokeWidth="22"
                    d="M-54,-514 C-46,-313 -205.42999267578125,-231.1529998779297 -329,-158 C-454,-84 -523,54 -435,178 C-327.3970031738281,329.62298583984375 -102,257 61,191.99899291992188 C252.28799438476562,115.71800231933594 556.0009765625,172 482,507"
                  ></path>
                </g>
              </g>
            </g>
          </svg>
          <div className="relative" id="start" style={{ width: "100%", height: "100%", zIndex:"2" }}>
            <Metrics/>          
            <ManifestText/>
          </div>
          
        </div>

        
        
        <div className="mx-2 md:mx-10">
          <div style={{ position: 'relative'}} className="w-full h-[52vw] max-h-[550px] max-w-[980px] mt-10 mx-auto rounded-[50px] border border-4 border-[#042040] hover:border-[#FED90F] shadow-[10px_10px_0px_#FED90F] hover:shadow-none ease-in duration-500 overflow-hidden bg-black">

          {visible ? 
            <iframe
              ref={vimeoIframeRef}
              title="Présentation heelio"
              src={"https://player.vimeo.com/video/878788541?autoplay=1&quality=1080p&title=0&byline=0&portrait=0&muted=1"}
              width={640}
              height={360}
              frameBorder="0"
              allowFullScreen
              style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex:0 }}
              className="aspect-video"
            >
            </iframe>
          :
            <div
              
            >
              <Image src='https://i.vimeocdn.com/video/1744893046-9880ac62c50516d71ddfdcaaa7cdbd3509cc60682bcaf76b1a9cad618193f404-d?mw=1000&mh=558' width={1920} height={1080} alt="video heelio" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex:0 }}/>
              <div className="cursor-pointer w-[10vw] max-w-[150px] max-h-[150px] h-[10vw] bg-[#FED90F] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full flex justify-center items-center border border-4 border-[#042040] hover:scale-110 duration-200 ease-in">
                <svg
                onClick={() => setVisible(true)}
                className=" max-w-[75px] max-h-[75px] cursor-pointer duration-500 ease-in" width="5vw" height="5vw" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.6582 9.28638C18.098 10.1862 18.8178 10.6361 19.0647 11.2122C19.2803 11.7152 19.2803 12.2847 19.0647 12.7878C18.8178 13.3638 18.098 13.8137 16.6582 14.7136L9.896 18.94C8.29805 19.9387 7.49907 20.4381 6.83973 20.385C6.26501 20.3388 5.73818 20.0469 5.3944 19.584C5 19.053 5 18.1108 5 16.2264V7.77357C5 5.88919 5 4.94701 5.3944 4.41598C5.73818 3.9531 6.26501 3.66111 6.83973 3.6149C7.49907 3.5619 8.29805 4.06126 9.896 5.05998L16.6582 9.28638Z" stroke="#042040" strokeWidth="2" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
            
          }
          </div>
        </div>

        <div ref={triggerDivRef}>
            </div>


        <Card/>
        

            

        <BusinessSector/>

        
        <Accompagnement/>
        <div id="reporting">
          <Reporting/>
        </div>
        
        <Security/>
        <Customer/>
        <JoinUs/>        
        <Faq/>
        <Footer/>
        <ScrollToTop 
          smooth 
          component={<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 5V19M12 5L6 11M12 5L18 11" stroke="#042040" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>}
        />

      </div>  
    </div>
      

  )
}
